import { MultiValuedList } from '../../MultiValuedList'
import { TextMultiValuedListItem } from '../TextMultiValuedListItem'
import { TextMultiValuedListMoreItem } from '../TextMultiValuedListMoreItem'

import { filterByChildren } from './TextMultiValuedList.utils'

function TextMultiValuedList({
  Item = TextMultiValuedListItem,
  MoreItem = TextMultiValuedListMoreItem,
  filter = filterByChildren,
  ...restProps
}) {
  return (
    <MultiValuedList
      {...restProps}
      Item={Item}
      MoreItem={MoreItem}
      filter={filter}
    />
  )
}

export default TextMultiValuedList
